function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M59.935,97.893c0,0-0.92,0.015-1.354-0.105l-1.665-0.405c-1.322-0.352-2.434-1.186-3.12-2.372   c-0.686-1.189-0.873-2.631-0.518-3.953l1.92-6.98H26.391l-2.754,10.091C23.038,96.403,21,98,18.684,98   c-0.447,0-0.894-0.041-1.329-0.155l-1.652-0.437c-1.322-0.354-2.428-1.199-3.115-2.389c-0.684-1.188-0.867-2.568-0.513-3.888   L35.161,5.871c0.6-2.239,2.637-3.803,4.954-3.803c0.448,0,0.895,0.059,1.33,0.176l1.651,0.443c1.324,0.354,2.43,1.203,3.115,2.391   c0.687,1.186,0.869,2.428,0.512,3.751l-1.926,6.413h28.807l2.759-9.51C76.962,3.49,78.999,2,81.315,2   c0.449,0,0.896,0.094,1.33,0.209l1.652,0.461c1.324,0.354,2.429,1.211,3.116,2.397c0.684,1.188,0.868,2.575,0.513,3.898   l-23.06,85.193c-0.601,2.24-2.401,3.731-4.93,3.731V97.893z M58.33,73.036l4.506-16.962H34.027l-4.506,16.962H58.33z M65.966,44.17   l4.505-16.16H41.663l-4.505,16.16H65.966z"
}));

var SvgLadder = function SvgLadder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLadder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ladder.21416a2d.svg";
export { ForwardRef as ReactComponent };